import React from "react";
import { faPaintRoller } from "@fortawesome/free-solid-svg-icons";
import SplitBadge from "./SplitBadge";
import { getElementMethodsValue } from "../utils/accessMethods";

/** Tree badge for access-method splits. */
const AccessMethodsBadge = ({ element, mode, onEdit }) => (
  <SplitBadge
    element={element}
    mode={mode}
    onEdit={onEdit}
    icon={faPaintRoller}
    getElementValue={getElementMethodsValue}
    popoverTitle="Access methods (m²)"
    emptyLabel="No access methods set"
    unassignedLabel="No methods"
  />
);

export default AccessMethodsBadge;
